var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.__get_style([_vm.$u.addStyle(_vm.customStyle)])
  var g0 = Math.floor(_vm.activeIndex)
  var g1 = !_vm.disabled ? Math.floor(_vm.activeIndex) : null
  var g2 = _vm.allowHalf ? _vm.$u.addUnit(_vm.rateWidth / 2) : null
  var g3 = _vm.allowHalf ? Math.ceil(_vm.activeIndex) : null
  var g4 = _vm.allowHalf && !_vm.disabled ? Math.ceil(_vm.activeIndex) : null
  var l0 = _vm.__map(Number(_vm.count), function (item, index) {
    var $orig = _vm.__get_orig(item)
    var a0 = {
      "padding-left": _vm.$u.addUnit(_vm.gutter / 2),
      "padding-right": _vm.$u.addUnit(_vm.gutter / 2),
    }
    var a1 = _vm.allowHalf
      ? {
          "padding-left": _vm.$u.addUnit(_vm.gutter / 2),
          "padding-right": _vm.$u.addUnit(_vm.gutter / 2),
        }
      : null
    return {
      $orig: $orig,
      a0: a0,
      a1: a1,
    }
  })
  if (!_vm._isMounted) {
    _vm.e0 = function ($event, index) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        index = _temp2.index
      var _temp, _temp2
      $event.stopPropagation()
      return _vm.clickHandler($event, index + 1)
    }
    _vm.e1 = function ($event, index) {
      var _temp3 = arguments[arguments.length - 1].currentTarget.dataset,
        _temp4 = _temp3.eventParams || _temp3["event-params"],
        index = _temp4.index
      var _temp3, _temp4
      $event.stopPropagation()
      return _vm.clickHandler($event, index + 1)
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        g0: g0,
        g1: g1,
        g2: g2,
        g3: g3,
        g4: g4,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }